<template>
<div>      
       <sidebar></sidebar>
    <div class="page">
      <!-- navbar-->
          <headermenu header="Profile"></headermenu>

       <section class="forms">
        <div class="container-fluid">
          <!-- Page Header-->
           <header> 
            <h1 class="h3 display">Customer Profile</h1>
          </header>

          <div class="row"> 

           <div class="col-lg-4">
              <div class="card card-profile">
                <div style="background-image: url(img/photos/paul-morris-116514-unsplash.jpg);" class="card-header"></div>
                <div class="card-body text-center"><img src="/static/images/profiles/profile-3.png" class="card-profile-img">
                  <h3 class="mb-3">TestCustomer3</h3>
                  <p class="mb-4">No3, Station Road, Moratuwa</p>
                  <button class="btn btn-outline-dark btn-sm"><span class="fa fa-twitter"></span> Follow</button>
                </div>
              </div>
           </div>

            <div class="col-lg-8">
              <div class="card">
                <div class="card-header">
                  <h4>Customer Credit Staement</h4>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Invoice No</th>
                          <th>Invoice Amount</th>
                          <th>Paid</th>
                          <th>Credit Note</th>
                          <th>SRN</th>
                          <th>Balance</th>
                          <th>Due Date</th>
                          <th>Inv. Days</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>2018-05-12</td>
                          <td>MAIN035173</td>
                          <td>6,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>6,660.00</td>
                          <td>2018-05-12</td>
                          <td>206Days</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>2018-06-12</td>
                          <td>MAIN033473</td>
                          <td>7,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>7,660.00</td>
                          <td>2018-08-12</td>
                          <td>216Days</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>2018-06-12</td>
                          <td>MAIN033473</td>
                          <td>8,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>7,660.00</td>
                          <td>2018-08-12</td>
                          <td>216Days</td>
                        </tr>
                        <tr>
                          <th scope="row">4</th>
                          <td>2018-06-12</td>
                          <td>MAIN043233</td>
                          <td>2,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>3,660.00</td>
                          <td>2018-08-12</td>
                          <td>216Days</td>
                        </tr>
                        <tr>
                          <th scope="row">5</th>
                          <td>2018-06-12</td>
                          <td>MAIN033473</td>
                          <td>3,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>1,660.00</td>
                          <td>2018-08-12</td>
                          <td>216Days</td>
                        </tr>
                        <tr>
                          <th scope="row">6</th>
                          <td>2018-06-12</td>
                          <td>MAIN033473</td>
                          <td>9,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>2,660.00</td>
                          <td>2018-08-12</td>
                          <td>216Days</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th>Total</th>
                          <th>Total Inv. Amt</th>
                          <th>Total Paid</th>
                          <th>Total Credit Note</th>
                          <th>Total SRN</th>
                          <th>Total Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row"></th>
                          <td>6,660.00</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>6,660.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                </div>
              </div>
            </div>


            <div class="col-lg-8">
              <div class="card">
                <div class="card-header">
                  <h4>Create Orders/Payment Receipts</h4>
                </div>
                <div class="card-body">
                        <button type="button" @click="addorder" class="btn btn-primary">Create Order</button>
                        <button type="button" class="btn btn-primary">Add Payments</button>

                </div>
              </div>
            </div>


        </div> 
        </div> 
    </section>           



    </div> 
</div>         

</template>

<script>

import headermenu from '@/components/supportcomp/headermenu.vue'      
import sidebar from '@/components/supportcomp/sidebar.vue'

export default {
  name: 'customerprofile',
  data () {
    return {
      msg: '',
      sideBarVisible : false,
      security_obj : '',
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false        
    }
  },
  components: {
      headermenu,
      sidebar
   },
methods: {
     
     addorder : function (){

             $(location).attr('href','./#/addorder');
          
      
      } //

  },
beforeMount : function() {

     var x = this;
     //setTimeout(function(){ }, 200);
    
},
mounted : function () {

}   
                
}


</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/components/customer_profile.vue